
import axios from 'axios';

export default axios.create({
    baseURL: 'https://dashboardawledna.futurevisions.tn/api/',


});